import { request } from "@/lib/api";

export function readOnboardingCodeLinkToken(search = "") {
  const params = new URLSearchParams(String(search || "").replace(/^\?/, ""));
  return String(params.get("t") || params.get("token") || "").trim();
}

export async function openOnboardingCodeLink(token) {
  return request("/api/whatsapp-onboarding/code-link", {
    method: "POST",
    requireAuth: false,
    body: JSON.stringify({ token }),
  });
}

export async function pollOnboardingCodeLink(token) {
  return request(`/api/whatsapp-onboarding/code-link?token=${encodeURIComponent(String(token || ""))}`, {
    requireAuth: false,
    forceFresh: true,
  });
}
